export default __webpack_public_path__ + "i18n/translations/translation-pl.dc5df3b8.json";